// eslint-disable-next-line
const BuildConfig = {
  HEAD_TITLE: 'TST Together',
  CUSTOMER: 'tst',
  DEFAULT_MAP_CENTER: {
    lat: 51.45354,
    lng: -0.46814,
  },
  // Where to draw a "school" marker on the maps. OPTIONAL, and empty here on purpose:
  // when a variant declares nothing, the marker falls back to DEFAULT_MAP_CENTER
  // above, which for a single-campus school IS the school. Declare this only where
  // that is wrong — a multi-campus school whose centre sits between its sites, or on
  // the main campus only.
  //
  // Shape: [{ lat: 50.857652, lng: 4.442393, name: 'Main campus' }, ...]
  // `name` is optional and renders as a caption under the marker; give every entry
  // one as soon as there is more than one, or the map shows two identical badges.
  //
  // NOTE lodash `merge` (src/env.config.js) blends arrays BY INDEX. That is safe only
  // while this default stays empty — putting an entry here would leave a variant's
  // first campus merged on top of it rather than replacing the list.
  SCHOOL_LOCATIONS: [],
  FEATURES: {
    retainAddressOnPinMove: false,
    ukCurriculumLabels: false,
  },
  IMPORT_CONFIG: {
    MIS: {
      imports: {
        users: false,
        routes: false,
        eca_events: false, // note this is module availability protected
      },
    },
    XLS: {
      imports: {
        users: true,
        routes: true,
        eca_events: true, // note this is module availability protected
      },
    },
  },
  EXPORT_CONFIG: {
    MIS: {
      exports: {
        users: false,
        routes: false,
        eca_events: false, // note this is module availability protected
      },
    },
    XLS: {
      exports: {
        users: true,
        routes: true,
        eca_events: true, // note this is module availability protected
      },
    },
  },
};

// used by env.config.js to merge global loaded (index.ejs) customer config
export const DefaultBuildConfig = BuildConfig;
